import React, { useCallback } from 'react'
import { Box } from '@mui/material'
import FormControlLabel from '@mui/material/FormControlLabel'

const sx = {
    root: {
        width: 56,
        height: 24,
        borderRadius: 15,
        background: 'linear-gradient(#6a6a69, #dfdfdf)',
        border: '1px solid #C9D3DA',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        opacity: 1,
        cursor: 'pointer',
        '&::before': {
            content: '"Hide"',
            position: 'absolute',
            left: 24,
            color: '#fff',
            fontWeight: 500,
            fontSize: 10
        },
        '&::after': {
            content: '""',
            display: 'block',
            width: 18,
            height: 18,
            background: 'white',
            position: 'absolute',
            top: 2,
            left: 2,
            borderRadius: '50%',
            transition: 'all 250ms ease-out',
        }
    },
    rootChecked: {
        background: '#0A78CD',
        '&::before': {
            content: '"Show"',
            left: 5,
        },
        '&::after': {
            left: 34,
        }
    },
    rootDisabled: {
        opacity: 0.5,
    },
    label: {
        marginLeft: theme => theme.spacing(2),
        fontWeight: 'bold',
        color: '#25245F'
    },
    labelRoot: {
        margin: 0
    }
}


const CustomCheckbox = props => {
    const { checked, label = '', name, disabled, onChange, customClasses } = props

    const onChangeInternal = useCallback(
        (event) => {
            if (onChange) {
                onChange(event, !checked)
            }
        },
        [checked, onChange]
    )

    let rootSx = [sx.root];

    if (props.checked) {
        rootSx.push(sx.rootChecked)
    }

    if (props.disabled) {
        rootSx.push(sx.rootDisabled)
    }

    return (
        <FormControlLabel
            classes={{ label: sx.label, root: [sx.labelRoot, customClasses?.labelRoot] }}
            label={label}
            disabled={disabled}
            control={
                <Box
                    sx={rootSx}>
                    <input
                        style={{ display: "none" }}
                        type="checkbox"
                        checked={checked}
                        name={name}
                        disabled={disabled}
                        onChange={onChangeInternal}
                    />
                </Box>
            }
        />
    )
}

export default CustomCheckbox
